import { Radio, RadioGroupProps } from "@mantine/core";
import React, { useRef } from "react";
import { IFocusableFormField } from "@type";

export interface IFormRadioGroupProps<Values = Record<string, unknown>>
  extends RadioGroupProps,
    IFocusableFormField<Values> {
  enumValue?: boolean;
}

export const FormRadioGroup: <Values = Record<string, unknown>>(
  props: IFormRadioGroupProps<Values>,
) => JSX.Element = ({ fieldName, parentForm, enumValue, ...rest }) => {
  const elementRef = useRef<HTMLInputElement>(null);
  parentForm.registerField(fieldName, elementRef);
  const inputProps = parentForm.getInputProps(fieldName);
  if (enumValue === true) {
    inputProps.value = inputProps.value
      ? Number(inputProps.value)
      : inputProps.value;
    const onChange = inputProps.onChange;
    inputProps.onChange = (value: any) =>
      onChange(value ? parseInt(value) : value);
  }
  return <Radio.Group {...inputProps} {...rest} ref={elementRef} />;
};
